import { ORGANISATION_STORAGE_KEY } from '../stores/organisation.atom';

export const getOrganisation = () => {
  const token = localStorage.getItem(ORGANISATION_STORAGE_KEY);

  if (!token) {
    return [];
  }

  return JSON.parse(token) as number[];
};

export default getOrganisation;
